import type { Stage } from '../../api/types';
import { stageSteps } from '../../lib/stages';

export interface StageTrackProps {
    stage: Stage | string | null | undefined;
}

/**
 * Хлебные крошки стадий (ТЗ §8.5). В макете их нет — блок собран на существующих
 * `.stage-chip.s-*`; обёртки `.stage-track` / `.st-step` добавлены в styles/index.css.
 * Стоит между `.modal-actions` и `.modal-tabs`: на тёмной шапке цвета чипов не читаются.
 */
export function StageTrack({ stage }: StageTrackProps) {
    return (
        <ol className="stage-track" aria-label="Стадия рассмотрения">
            {stageSteps(stage).map((step) => (
                <li key={step.stage} className={step.state === 'todo' ? 'st-step' : 'st-step ' + step.state}>
                    <span
                        className={'stage-chip s-' + step.stage}
                        aria-current={step.state === 'current' ? 'step' : undefined}
                    >
                        {step.label}
                    </span>
                </li>
            ))}
        </ol>
    );
}

export default StageTrack;
